import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';

import { Button, Col, Drawer, Form, Input, Modal, Row, Tooltip } from 'antd';
import moment from 'moment';

import FloatingLabel from '../../../components/FloatingLabel/FloatingLabel';
import NonAccreditedModal from '../../../components/NonAccreditedModal';
import PinModal from '../../../components/PinModal/PinModal';
import SuccessModal from '../../../components/SuccessModal/SuccessModal';
import ChangePassword from './Modals/ChangePassword';
import EditAccDetails from './Modals/EditAccDetails';
import EditAddress from './Modals/EditAddress';
import EditEntityAddress from './Modals/EditEntityAddress';
import EditEntityDetails from './Modals/EditEntityDetails';
import EditIdDetails from './Modals/EditIdDetails';
import NameChange from './Modals/NameChange';
import ResetPin from './Modals/ResetPin';

import { CloseIcon, Edit, Information, Warning } from '../../../assets/icons';

import { ACCOUNT_TYPES } from '../../../constants/accountType.constants';
import useGetUserProfile from '../../../Hooks/useGetUserProfile';
import useMediaQuery from '../../../Hooks/useMediaQuery';
import { resendEmailAndPhoneCode, resetLoginPin, verifyEmailAndPhoneCode } from '../../../services/AccountApi/profileApi';
import { trueEmailVerifyed, trueMobileVerifyed } from '../../../store/reducer/accountSlice';
import { ENTITY_INFORMATION_KYB_APPROVED_MESSAGE } from '../../../utils/constant';
import { decryptEIN, maskEIN } from '../../../utils/einDecryption';
import { formatePhoneNumber } from '../../../utils/formatPhoneNumber';
import { toastNotify } from '../../../utils/toastNotify';

import './Profile.scss';

const Profile = () => {
  const screenMD = useMediaQuery('(min-width: 1000px)');
  const { setLoading } = useOutletContext();
  const userProfileData = useSelector((state) => state.userData.userData);
  const [successOpen, setSuccessOpen] = useState(false);
  const [openPinModal, setOpenPinModal] = useState(0);
  const [editPersonal, setEditPersonal] = useState(false);
  const [editAddress, setEditAddress] = useState(false);
  const [editEntityDetails, setEditEntityDetails] = useState(false);
  const [editEntityAddress, setEditEntityAddress] = useState(false);
  const [editIdDetails, setEditIdDetails] = useState(false);
  const [, setEditAccreditDetails] = useState(false);
  const [resetPin, setResetPin] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [openNameChange, setOpenNameChange] = useState(false);
  const [verifyCode, setverifyCode] = useState();
  const [reVerifyModal, setReVerifyModal] = useState('');
  const [verifyModal, setVerifyModal] = useState('');
  const [butttonLoading, setButtonLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [countDown, setCountDown] = useState(0);
  const [isShowResend, setShowResend] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [isSelfAttestment, setIsSelfAttestment] = useState(false);
  const [, setIsEditAccredit] = useState(false);

  useGetUserProfile();

  const dispatch = useDispatch();
  const addressDeatilOne =
    Object.keys(userProfileData)?.length > 0 && `${userProfileData?.address?.residentialAdd}, ${userProfileData?.address?.apartmentNumber || ''}`;
  const phoneNumber = formatePhoneNumber(userProfileData?.phoneNumber);
  const ssnFormate = `XXX-XX-X${userProfileData?.ssn?.slice(8, 11)}`;
  const isEntityAccount = userProfileData?.accountType === ACCOUNT_TYPES.ENTITY;
  const entityProfile = userProfileData?.entityProfile;
  const isKYBApproved = entityProfile?.isKYBApproved;
  const entityEinFormate = maskEIN(decryptEIN(entityProfile?.encodedEIN));
  const entityAddressLineOne = entityProfile?.entityAddress
    ? `${entityProfile.entityAddress.residentialAdd || ''}${
        entityProfile.entityAddress.apartmentNumber ? `, ${entityProfile.entityAddress.apartmentNumber}` : ''
      }`
    : '';
  const { slug } = useParams();
  const navigate = useNavigate();
  const counter = useSelector((state) => state.userData.counter);
  const userData = useSelector((state) => state.userData);

  const VERIFICATION_TYPE = {
    EMAIL: 'email',
    PHONE_NUMBER: 'phone number',
  };
  useEffect(() => {
    if (slug === 'name-change') {
      setOpenNameChange(true);
    }
  }, []);

  const handleResetLoginPin = async () => {
    setLoading(true);
    try {
      const resData = await resetLoginPin();
      if (!resData.isError) {
        toastNotify('success', resData?.message);
        setResetPin(true);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  const handleCloseNameChangeModal = () => {
    setOpenNameChange(false);
    navigate('/account', { replace: true });
  };

  const hideVerifyModal = () => {
    setVerifyModal('');
    setverifyCode('');
  };

  const showReVerifyModal = (value) => {
    // If the countdown is still active, show the verify modal directly
    if (isShowResend && countDown > 0) {
      setVerifyModal(value);
    } else {
      // Otherwise show the re-verify modal first
      setReVerifyModal(value);
    }
  };
  const hideReVerifyModal = () => {
    setReVerifyModal('');
  };

  const sendEmailAndPhoneCode = async (value, shoulCloseVerificationModal) => {
    const type = value === VERIFICATION_TYPE.EMAIL ? 0 : 1;
    const resp = await resendEmailAndPhoneCode({ type });
    if (!resp.isError) {
      timerCounter();
      shoulCloseVerificationModal && setVerifyModal(reVerifyModal);
      hideReVerifyModal();
      toastNotify('success', resp?.message);
    } else {
      toastNotify('error', resp?.message);
    }
  };

  const handleSendCode = async (value, shoulCloseVerificationModal) => {
    try {
      setButtonLoading(true);
      await sendEmailAndPhoneCode(value, shoulCloseVerificationModal);
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setButtonLoading(false);
    }
  };

  const handleResendCode = async (value, shoulCloseVerificationModal) => {
    try {
      setResendLoading(true);
      await sendEmailAndPhoneCode(value, shoulCloseVerificationModal);
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setResendLoading(false);
    }
  };

  const handleVerifyCode = async (value) => {
    setButtonLoading(true);
    const formValue = {
      type: value === VERIFICATION_TYPE.EMAIL ? 0 : 1,
      code: Number(verifyCode),
    };
    try {
      const resp = await verifyEmailAndPhoneCode(formValue);
      if (!resp.isError) {
        value === VERIFICATION_TYPE.EMAIL ? await dispatch(trueEmailVerifyed()) : await dispatch(trueMobileVerifyed());
        hideVerifyModal();
        setverifyCode('');
        toastNotify('success', resp?.message);
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setButtonLoading(false);
    }
  };
  const timerCounter = (timerValue = 30) => {
    setShowResend(true);
    let timeleft = timerValue;
    const downloadTimer = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
        setCountDown(0);
        setShowResend(false);
      } else {
        if (timeleft < 10) {
          timeleft = 0 + '' + timeleft;
        }
        setCountDown(timeleft);
      }
      timeleft -= 1;
    }, 1000);
  };

  const reVerifyModalContent = [
    <>
      {screenMD && <h4 className='text-center mb-16'>Resend verification code</h4>}
      {reVerifyModal === VERIFICATION_TYPE.EMAIL ? (
        <p className='mb-48 text-taupe'>
          To enhance security, please verify your phone number. Click the button below to receive a new verification code to
          <span className='fw-600 text-almost-black'>{' ' + userProfileData?.email}.</span>
        </p>
      ) : (
        <p className='mb-48 text-taupe'>
          To enhance security, please verify your phone number. Click the button below to receive a new verification code to
          <span className='fw-600 text-almost-black ml-5'> {phoneNumber}.</span>
        </p>
      )}
      {screenMD && (
        <Button loading={butttonLoading} onClick={() => handleSendCode(reVerifyModal, true)} type='primary' className='w-100'>
          Send code
        </Button>
      )}
    </>,
  ];

  const verifyModalContent = [
    <>
      {screenMD && <h4 className='text-center mb-16'>Verify {verifyModal === VERIFICATION_TYPE.EMAIL ? 'email' : 'phone number'}</h4>}
      {verifyModal === VERIFICATION_TYPE.EMAIL ? (
        <p className='mb-30 text-taupe'>
          We have sent a verification code to <span className='fw-600 text-almost-black'>{' ' + userProfileData?.email}.</span> Please enter the code
          below to verify your email.
        </p>
      ) : (
        <p className='mb-30 text-taupe'>
          We have sent a verification code to <span className='fw-600 text-almost-black'> {phoneNumber}.</span> Please enter the code below to verify
          your email.
        </p>
      )}
      <FloatingLabel inputValue={verifyCode} label='Verification code' inputId='name'>
        <Form.Item className='mb-48'>
          <Input
            value={verifyCode}
            id='name'
            onChange={(e) => setverifyCode(e.target.value.replace(/\D/g, ''))}
            maxLength={6}
            onKeyPress={(event) => {
              if (event?.target?.value?.length === 6 && event.key === 'Enter') {
                handleVerifyCode(verifyModal);
              }
            }}
          />
        </Form.Item>
      </FloatingLabel>
      {screenMD && (
        <Row gutter={16}>
          <Col span={12}>
            <Button disabled={isShowResend} loading={resendLoading} onClick={() => handleResendCode(verifyModal, false)} className='w-100 px-0'>
              Resend code
              {countDown > 0 && <span className='ml-4'>in {<span>{`${countDown}`}</span>}s</span>}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              disabled={verifyCode?.length === 6 ? false : true}
              loading={butttonLoading}
              onClick={() => handleVerifyCode(verifyModal)}
              type='primary'
              className='w-100'
            >
              Verify
            </Button>
          </Col>
        </Row>
      )}
    </>,
  ];

  // STEP FOUR FORM SUBMIT
  return (
    <>
      <div className='profile'>
        <h4 className='profile__title'>Account Details</h4>
        <div className='profile__section'>
          <div className='profile__section__title'>
            <p>{'Personal'}</p>
            {userData?.userData?.isUsCitizen === true ? (
              userData?.userData?.isKYCVerified && <Edit color='#726460' onClick={() => setOpenPinModal(1)} />
            ) : (
              <Edit color='#726460' onClick={() => setOpenPinModal(1)} />
            )}
          </div>
          <div className='profile__section__data data'>
            <div className='data__field'>
              <p className='data__field__name'>First name</p>
              <p className='data__field__value'>{userProfileData?.firstName}</p>
            </div>
            <div className='data__field'>
              <p className='data__field__name'>Last name</p>
              <p className='data__field__value'>{userProfileData?.lastName}</p>
            </div>
            <div className='data__field'>
              <p className='data__field__name'>Email address</p>
              <p className='data__field__value'>
                {!userProfileData?.isEmailVerified && (
                  <span onClick={() => showReVerifyModal(VERIFICATION_TYPE.EMAIL)} className='text-error mr-24 fw-600 underline fz-14 cursor-pointer'>
                    <Warning verticalAlign='-5px' marginRight='8px' />
                    Unverified
                  </span>
                )}
                {userProfileData?.email}
              </p>
            </div>
            <div className='data__field'>
              <p className='data__field__name'>Phone number</p>
              {userProfileData?.phoneNumber ? (
                <p className='data__field__value'>
                  {!userProfileData?.isPhoneVerified && (
                    <span
                      onClick={() => showReVerifyModal(VERIFICATION_TYPE.PHONE_NUMBER)}
                      className='text-error mr-24 fw-600 underline fz-14 cursor-pointer'
                    >
                      <Warning verticalAlign='-5px' marginRight='8px' />
                      Unverified
                    </span>
                  )}
                  {phoneNumber}
                </p>
              ) : (
                <p className='data__field__error'>Required</p>
              )}
            </div>
          </div>
        </div>
        {addressDeatilOne && userProfileData?.address?.zipCode && userProfileData?.address?.city && (
          <div className='profile__section'>
            <div className='profile__section__title'>
              <p>{'Address'}</p>
              {userData?.userData?.isKYCVerified && <Edit color='#726460' onClick={() => setEditAddress(true)} />}
            </div>
            <div className='profile__section__data data'>
              <div className='data__field'>
                <p className='data__field__name'>Street address</p>
                <p className='data__field__value'>{addressDeatilOne}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>Postal code</p>
                <p className='data__field__value'>{userProfileData?.address?.zipCode}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>City</p>
                <p className='data__field__value'>{userProfileData?.address?.city}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>Country</p>
                <p className='data__field__value'>{'United States'}</p>
              </div>
            </div>
          </div>
        )}
        {isEntityAccount && entityProfile && (
          <div className='profile__section'>
            <div className='profile__section__title'>
              <p>{'Entity Information'}</p>
              {isKYBApproved ? (
                <Tooltip title={ENTITY_INFORMATION_KYB_APPROVED_MESSAGE}>
                  <span>
                    <Information size={24} className='cursor-pointer' color='#726460' />
                  </span>
                </Tooltip>
              ) : (
                <Edit color='#726460' onClick={() => setEditEntityDetails(true)} />
              )}
            </div>
            <div className='profile__section__data data'>
              <div className='data__field'>
                <p className='data__field__name'>Entity name</p>
                <p className='data__field__value'>{entityProfile?.entityName}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>Entity type</p>
                <p className='data__field__value'>{entityProfile?.entityType}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>Employer Identification Number</p>
                <p className='data__field__value'>{entityProfile?.encodedEIN ? entityEinFormate : 'N/A'}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>State of incorporation/formation</p>
                <p className='data__field__value'>{entityProfile?.stateOfIncorporation}</p>
              </div>
            </div>
          </div>
        )}
        {isEntityAccount && entityProfile?.entityAddress && (
          <div className='profile__section'>
            <div className='profile__section__title'>
              <p>{'Entity Address'}</p>
              <Edit color='#726460' onClick={() => setEditEntityAddress(true)} />
            </div>
            <div className='profile__section__data data'>
              <div className='data__field'>
                <p className='data__field__name'>Street address</p>
                <p className='data__field__value'>{entityAddressLineOne}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>Postal code</p>
                <p className='data__field__value'>{entityProfile?.entityAddress?.zipCode}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>City</p>
                <p className='data__field__value'>{entityProfile?.entityAddress?.city}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>Country</p>
                <p className='data__field__value'>{'United States'}</p>
              </div>
            </div>
          </div>
        )}
        {counter > 1 && userProfileData?.citizenshipStatus && (
          <div className='profile__section'>
            <div className='profile__section__title'>
              <p>{'Identification'}</p>
              {userData?.userData?.isKYCVerified && <Edit color='#726460' onClick={() => setEditIdDetails(true)} />}
            </div>
            <div className='profile__section__data data'>
              <div className='data__field'>
                <p className='data__field__name'>Citizenship status</p>
                <p className='data__field__value'>{userProfileData?.citizenshipStatus}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>Date of birth</p>
                {userProfileData?.dob ? (
                  <p className='data__field__value'>{moment(userProfileData?.dob).format('MMM DD, YYYY')}</p>
                ) : (
                  <p className='data__field__error'>Required</p>
                )}
              </div>
              <div className='data__field'>
                <p className='data__field__name'>SSN</p>
                {userProfileData?.ssn ? <p className='data__field__value'>{ssnFormate}</p> : <p className='data__field__error'>Required</p>}
              </div>
            </div>
          </div>
        )}
        {/* Comment for Temp to Hide Accredited Investor details */}
        {/* {userProfileData?.dob && userProfileData?.ssn && (
          <div className='profile__section'>
            <div className='profile__section__title'>
              <p>{'Investor Accreditation'}</p>
              {userData?.userData?.isKYCVerified && <Edit color='#726460' onClick={() => setEditAccreditDetails(true)} />}
            </div>
            <div className='profile__section__data data'>
              <div className='data__field'>
                <p className='data__field__name'>Accreditation status</p>
                <p className='data__field__value'>{accreditationStatus}</p>
              </div>
              <div className='data__field'>
                <p className='data__field__name'>Regulation D status</p>
                <p className='data__field__value'>{userProfileData?.isRegDInvestor}</p>
              </div>
            </div>
          </div>
        )} */}
        <div className='profile__section'>
          <p className='profile__section__link' onClick={() => setOpenPinModal(5)}>
            Change password
          </p>
          <p className='profile__section__link' onClick={() => handleResetLoginPin()}>
            Reset login PIN
          </p>
        </div>
        {openPinModal === 1 && (
          <PinModal
            setOpen={openPinModal === 1}
            setClose={() => setOpenPinModal(0)}
            clickAction={() => {
              setOpenPinModal(0);
              setEditPersonal(true);
            }}
          />
        )}
        <EditAccDetails
          setOpen={editPersonal}
          setEditModal={(e) => setEditPersonal(e)}
          userProfileData={Object.keys(userProfileData).length > 0 && userProfileData}
        />
        {openPinModal === 2 && (
          <PinModal
            setOpen={openPinModal === 2}
            setClose={() => setOpenPinModal(0)}
            clickAction={() => {
              setOpenPinModal(0);
              setEditAddress(true);
            }}
          />
        )}
        {userProfileData?.address && editAddress && (
          <EditAddress
            setOpen={editAddress}
            setClose={() => setEditAddress(false)}
            addressData={Object.keys(userProfileData).length > 0 && userProfileData?.address}
            // setResetPinLoading={() => setResetPinLoading(true)}
          />
        )}
        {isEntityAccount && editEntityDetails && (
          <EditEntityDetails setOpen={editEntityDetails} setClose={() => setEditEntityDetails(false)} entityProfile={entityProfile} />
        )}
        {isEntityAccount && entityProfile?.entityAddress && editEntityAddress && (
          <EditEntityAddress
            setOpen={editEntityAddress}
            setClose={() => setEditEntityAddress(false)}
            entityAddressData={entityProfile?.entityAddress}
          />
        )}
        {/* <PinModal
        setOpen={openPinModal === 3}
        setClose={() => setOpenPinModal(0)}
        clickAction={() => {
          setOpenPinModal(0);
          setEditIdDetails(true);
        }}
      /> */}
        {editIdDetails && (
          <EditIdDetails
            setOpen={editIdDetails}
            setClose={() => setEditIdDetails(false)}
            userProfileData={Object.keys(userProfileData).length > 0 && userProfileData}
            // setResetPinLoading={() => setResetPinLoading(true)}
          />
        )}
        {openPinModal === 4 && (
          <PinModal
            setOpen={openPinModal === 4}
            setClose={() => setOpenPinModal(0)}
            clickAction={() => {
              setOpenPinModal(0);
              setEditAccreditDetails(true);
            }}
          />
        )}
        {/* {editAccreditDetails && (
          <EditAccreditDetails
            setOpen={editAccreditDetails}
            setClose={(value) => setEditAccreditDetails(value)}
            userProfileData={Object.keys(userProfileData).length > 0 && userProfileData}
            successOpen={successOpen}
            setSuccessOpen={setSuccessOpen}
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            isEditAccredit={isEditAccredit}
            setIsEditAccredit={setIsEditAccredit}
            setIsSelfAttestment={setIsSelfAttestment}
            isSelfAttestment={isSelfAttestment}
          />
        )} */}
        {resetPin && <ResetPin phoneNumber={phoneNumber} setOpen={resetPin} setClose={() => setResetPin(false)} mail={userProfileData?.email} />}
        {openPinModal === 5 && (
          <PinModal
            setOpen={openPinModal === 5}
            setClose={() => setOpenPinModal(0)}
            clickAction={() => {
              setOpenPinModal(0);
              setChangePassword(true);
            }}
          >
            <p className='mb-40'>
              Forgot your PIN?{' '}
              <span
                className='fw-600 cursor-pointer text-terracotta underline'
                onClick={() => {
                  setOpenPinModal(0);
                  handleResetLoginPin();
                }}
              >
                Request reset
              </span>
            </p>
          </PinModal>
        )}
        <ChangePassword
          email={userProfileData?.email}
          setPinModal={setResetPin}
          setOpen={changePassword}
          setClose={() => setChangePassword(false)}
          isPasswordSet={userProfileData.isPasswordSet}
        />
        <NameChange // Legal Name change Modal
          setOpen={openNameChange}
          setClose={() => handleCloseNameChangeModal()}
        />
      </div>
      {screenMD && (
        <>
          <Modal
            className=''
            open={reVerifyModal !== ''}
            onCancel={hideReVerifyModal}
            header={false}
            footer={false}
            width={524}
            closeIcon={<CloseIcon />}
            centered
          >
            {reVerifyModalContent}
          </Modal>
          <Modal
            className=''
            open={verifyModal !== ''}
            onCancel={hideVerifyModal}
            header={false}
            footer={false}
            width={524}
            closeIcon={<CloseIcon />}
            centered
          >
            {verifyModalContent}
          </Modal>
        </>
      )}
      <Drawer
        className='footer-shadow quickbuy--drawer'
        width='100%'
        title={<p className='subhead-2 mb-0 ml-40 text-center'>Resend verification code</p>}
        onClose={hideReVerifyModal}
        open={reVerifyModal !== ''}
        closeIcon={<CloseIcon />}
        footer={
          <Row>
            <Col span={24}>
              <Button onClick={() => handleSendCode(reVerifyModal, true)} type='primary' className='w-100'>
                Send code
              </Button>
            </Col>
          </Row>
        }
      >
        {reVerifyModalContent}
      </Drawer>
      {verifyModal && (
        <Drawer
          className='footer-shadow quickbuy--drawer'
          width='100%'
          title={
            <p className='subhead-2 mb-0 ml-40 text-center'>{reVerifyModal === VERIFICATION_TYPE.EMAIL ? 'Verify email' : 'Verify phone number'}</p>
          }
          onClose={hideVerifyModal}
          open={verifyModal}
          closeIcon={<CloseIcon />}
          footer={
            <Row gutter={16}>
              <Col span={24}>
                <Button disabled={isShowResend} loading={resendLoading} onClick={() => handleResendCode(verifyModal, false)} className='w-100 mb-16'>
                  Resend code
                  {countDown > 0 && <span className='ml-4'>in {<span>{`${countDown}`}</span>}s</span>}
                </Button>
              </Col>
              <Col span={24}>
                <Button
                  loading={butttonLoading}
                  disabled={verifyCode?.length === 6 ? false : true}
                  onClick={() => handleVerifyCode(verifyModal)}
                  type='primary'
                  className='w-100'
                >
                  Verify
                </Button>
              </Col>
            </Row>
          }
        >
          {verifyModalContent}
        </Drawer>
      )}
      <SuccessModal
        description='Your updates have been saved successfully. If your investor accreditation changes, you must update your status accordingly in order to invest with Realbricks.'
        setOpen={successOpen}
        setClose={() => {
          setIsEditAccredit(false);
          setSuccessOpen(false);
        }}
        setDone={() => {
          setIsEditAccredit(false);
          setSuccessOpen(false);
        }}
      />
      <NonAccreditedModal
        modalOpen={modalOpen}
        setIsSelfAttestment={setIsSelfAttestment}
        setModalOpen={(value) => {
          setIsEditAccredit(true);
          setModalOpen(value);
          setEditAccreditDetails(value);
        }}
        setModalClose={() => setEditAccreditDetails(true)}
        isSelfAttestment={isSelfAttestment}
        setSuccessOpen={setSuccessOpen}
      />
    </>
  );
};

export default Profile;
